// @styles
require('./aggregatorTinkInfoSettings.scss');

// @vendors
import React from 'react';

// @components
import { ContentBox } from 'commonsComponents/contentBox';

// @utilities
const { formatText } = require('core/i18n').i18n;

// assets
import infoIcon from '../../../../routes/aggregatorTink/assets/info.svg';

function AggregatorTinkInfoSettings() {
  return (
    <ContentBox
      title={formatText('aggregatorManageEntities-infoTitle')}
      smallTitle={true}
      customClassName="aggregator-tink-info-settings__box"
    >
      <div className="aggregator-tink-info-settings__content">
        <div className="aggregator-tink-info-settings__content__list">
          <ul>
            <li className="aggregator-tink-info-settings__content__list__item">
              {formatText('aggregatorManageEntities-infoItem1')}
            </li>
            <li className="aggregator-tink-info-settings__content__list__item">
              {formatText('aggregatorManageEntities-infoItem2')}
            </li>
            <li className="aggregator-tink-info-settings__content__list__item">
              {formatText('aggregatorManageEntities-infoItem3')}
            </li>
          </ul>
        </div>
        <img className="aggregator-tink-info-settings__content__icon" src={infoIcon} />
      </div>
    </ContentBox>
  );
}

export default AggregatorTinkInfoSettings;
